import { NgStyle } from '@angular/common'
import { Component, OnInit, Input, OnDestroy, inject } from '@angular/core'
import { takeUntil } from 'rxjs'

import { ResponsiveComponent } from '@nx-superprep/shared'
import { UserService } from '@nx-superprep/backend/firebase'

@Component({
  standalone: true,
  selector: 'pop-ui-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [NgStyle],
})
export class AvatarComponent extends ResponsiveComponent implements OnInit, OnDestroy {

  private _showPhoto = false
  @Input() public get showPhoto() {
    return this._showPhoto
  }
  set showPhoto(value) {
    this._showPhoto = value && (this.userService.activeUser?.photoURL??'').length > 0
  }
  @Input() showFullName = false

  color = 'blueviolet'
  photoURL = ''
  public initials = ''
  first = ''
  last = ''

  override ngOnInit() {
    super.ngOnInit()
    this.userService.getInfo()
    .pipe(takeUntil(this.onDestroy))
    .subscribe((info) => {
      if (!info) { return }
      this.color = this.userService.activeUser?.color ?? 'blueviolet'
      this.photoURL = this.userService.activeUser?.photoURL??''
      this.createInititals(info.profileName??info.firstName)
      this.first = info.firstName
      this.last = info.lastName
    })
  }

  private createInititals(name = 'Guest'): void {
    let initials = name.charAt(0).toUpperCase()

    for (let i = 1; i < name.length; i++) {
      if (name.charAt(i) === ' ') { continue }
      if (name.charAt(i) === name.charAt(i).toUpperCase()) {
        initials += name.charAt(i)
        if (initials.length === 2) { break }
      }
    }
    this.initials = initials[0]
  }

  readonly userService = inject(UserService)
}
